"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styled_components_1 = require("styled-components");
const oxygen_config_1 = require("@8x8/oxygen-config");
const StyledSvg_1 = __importDefault(require("../styled/Spinner/StyledSvg"));
const themeName_1 = require("../constants/themeName");
const types_1 = require("../types");
const safeNum = 0.1;
const sizeToBorderRatio = 24;
const GAP_PERCENTAGE = 0.83;
const getSize = ({ theme, size }) => {
    if (typeof size === 'number') {
        return size;
    }
    if (size === types_1.spinnerSize.small) {
        return theme.widthSpinnerSmall;
    }
    if (size === types_1.spinnerSize.large2x) {
        return theme.widthSpinnerExtraLarge;
    }
    return theme.widthSpinnerDefault;
};
const Spinner = ({ testId, theme, size, strokeWidth, ...rest }) => {
    const computedSize = getSize({ theme, size });
    const finalStrokeWidth = strokeWidth || computedSize / sizeToBorderRatio;
    const computedSizeHalf = Math.max(safeNum, Math.floor(computedSize / 2));
    const computedSizeQuarter = Math.max(safeNum, Math.floor(computedSizeHalf / 2));
    const computedRadius = Math.max(safeNum, computedSizeQuarter - finalStrokeWidth);
    // computed value for circle gap to create spinner ilussion
    // GAP_PERCENTAGE is how much of the circle should be visible
    const computedStrokeGap = 2 * Math.PI * computedRadius * GAP_PERCENTAGE;
    return (react_1.default.createElement(styled_components_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(StyledSvg_1.default, { ...(0, oxygen_config_1.getTestAttributes)(testId), ...rest, fill: "none", xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid", viewBox: `0 0 ${computedSizeHalf} ${computedSizeHalf}`, height: `${computedSize}px`, width: `${computedSize}px` },
            react_1.default.createElement("circle", { r: computedRadius, cx: computedSizeQuarter, cy: computedSizeQuarter, fill: "none", stroke: theme.withSpinnerBackground ? theme.backgroundContainer : 'none', strokeWidth: finalStrokeWidth }),
            react_1.default.createElement("circle", { r: computedRadius, cx: computedSizeQuarter, cy: computedSizeQuarter, fill: "none", stroke: theme.backgroundFiller, strokeWidth: finalStrokeWidth, strokeLinecap: "round", strokeDasharray: computedStrokeGap }))));
};
Spinner.propTypes = {
    /**
     * Spinner test id
     */
    testId: prop_types_1.default.string,
    /**
     * Spinner theme
     */
    theme: prop_types_1.default.object.isRequired,
    /**
     * Define Spinner size
     */
    size: prop_types_1.default.oneOfType([
        prop_types_1.default.number,
        prop_types_1.default.oneOf(Object.values(types_1.spinnerSize)),
    ]),
    /**
     * Define Spinner stroke size
     */
    strokeWidth: prop_types_1.default.number,
    /**
     * Tell when Spinner is animated
     */
    hasAnimation: prop_types_1.default.bool,
};
Spinner.defaultProps = {
    testId: 'SPINNER',
    size: 'default',
    strokeWidth: undefined,
    hasAnimation: true,
};
exports.default = (0, oxygen_config_1.withTheme)(Spinner, themeName_1.THEME_NAME);
